<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="$store.getters['routeIsLoading']" :can-cancel="false"></b-loading>
    <!-- <div class="box has-background-light"> -->
      <h1 class="is-size-3">Code Chain Validator</h1>
      <hr>
      <div>
        <button type="button" class="button is-primary is-medium" :disabled="dropdownsBusy" @click="resetCodes">Reset</button>
      </div>
      <hr>
      <div class="columns">
        <div class="column is-2">
          <!-- <b-field label="Code Set">
            <b-select
              label="CODE SET"
              expanded
              :loading="dropdownsBusy"
              :disabled="dropdownsBusy"
              v-model="code_set"
            >
              <option :value="null">Please Select</option>
              <option
                v-for="set in code_sets"
                :value="set.value"
                :key="set.value"
              >
                {{ set.text }}
              </option>
            </b-select>
          </b-field> -->
        </div>
      </div>
      <div class="columns">
        <div class="column is-2">
          <b-field label="Order Type">
            <b-select v-model="selected.order_type_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in orderTypeCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Activity Type">
            <b-select v-model="selected.activity_type_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in activityTypeCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label="Activity Code">
            <b-select v-model="selected.activity_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in activityCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label="Problem Code">
            <b-select v-model="selected.problem_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
                <option :value="null">Please Select</option>
                <option
                    v-for="code in problemCodes"
                    :value="code.id"
                    :key="code.id">
                    {{ displayCode(code) }}
                </option>
            </b-select>
          </b-field>
          <b-field label="Asset Code">
            <b-select v-model="selected.asset_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in assetCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label="Outcome Code">
            <b-select v-model="selected.outcome_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in outcomeCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Responsibility Code">
            <b-select v-model="selected.responsibility_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in responsibilityCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-2">
          <b-field label="Failure Code">
            <b-select v-model="selected.failure_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in failureCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Repair Code">
            <b-select v-model="selected.repair_code_id" placeholder="Please Select" expanded :loading="dropdownsBusy" :disabled="dropdownsBusy">
              <option :value="null">Please Select</option>
              <option
                  v-for="code in repairCodes"
                  :value="code.id"
                  :key="code.id">
                  {{ displayCode(code) }}
              </option>
            </b-select>
          </b-field>
        </div>
        <!-- <div class="column is-2">two</div>         -->
      </div>
      <h2 class="is-size-4">Available Options</h2>
      <hr>
      <p v-if="codes_filtered.length == 0" class="has-text-grey">
        No results available.
      </p>
      <div v-else class="columns">

        <div class="column is-2">
          <div>
            <strong>Order Type</strong>
            <ul v-if="orderTypeCodesFiltered.length > 0">
              <li v-for="code in orderTypeCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
          <hr>
          <div>
            <strong>Activity Type</strong>
            <ul v-if="activityTypeCodesFiltered.length > 0">
              <li v-for="code in activityTypeCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
        </div>

        <div class="column is-2">
          <div>
            <strong>Activity Code</strong>
            <ul v-if="activityCodesFiltered.length > 0">
              <li v-for="code in activityCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
        </div>

        <div class="column is-2">
          <div>
            <strong>Problem Code</strong>
            <ul v-if="problemCodesFiltered.length > 0">
              <li v-for="code in problemCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
          <hr>
          <div>
            <strong>Asset Code</strong>
            <ul v-if="assetCodesFiltered.length > 0">
              <li v-for="code in assetCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
        </div>

        <div class="column is-2">
          <div>
            <strong>Outcome Code</strong>
            <ul v-if="outcomeCodesFiltered.length > 0">
              <li v-for="code in outcomeCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
          <hr>
          <div>
            <strong>Responsibility Code</strong>
            <ul v-if="responsibilityCodesFiltered.length > 0">
              <li v-for="code in responsibilityCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
        </div>

        <div class="column is-2">
          <div>
            <strong>Failure Code</strong>
            <ul v-if="failureCodesFiltered.length > 0">
              <li v-for="code in failureCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
          <hr>
          <div>
            <strong>Repair Code</strong>
            <ul v-if="repairCodesFiltered.length > 0">
              <li v-for="code in repairCodesFiltered" :key="code.id">{{ displayCode(code) }}</li>
            </ul>
            <p v-else class="has-text-grey">No results</p>
          </div>
        </div>

        <!--
        <div v-for="(set, type_key) in filteredCodesByType" :key="`type_${type_key}`" class="column is-2">
          <strong>{{ type_key }}</strong>
          <ul v-if="set.length > 0">
            <li v-for="code in set" :key="code.id">{{displayCode(code) }}</li>
          </ul>
          <p v-else class="has-text-grey">No results</p>
        </div>
        -->
      </div>
      <hr>
    <!-- </div> -->
  </div>
</template>

<script>
import { ApiUtil } from "@/utils/api.util.js";
import { CodeService } from "@/services/code.service";
import { ContractService } from "@/services/contract.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import trim from 'lodash/trim';

export default {
  name: 'CodesChain',
  data: () => ({
    code_set: null,
    code_sets: [],
    codes_all: [],
    codes_filtered: [],
    selected: {
      order_type_code_id: null,
      activity_type_code_id: null,
      problem_code_id: null,
      activity_code_id: null,
      failure_code_id: null,
      repair_code_id: null,
      outcome_code_id: null,
      responsibility_code_id: null,
    },
    chainLoading: false
  }),
  watch: {
    code_set() {
      this.resetCodes();
      this.$nextTick(() => {
        this.fetchAll();
      });
    },
    selected: {
      deep: true,
      handler: 'fetchChained'
    }
  },
  computed: {
    dropdownsBusy() {
      return this.chainLoading || this.$store.getters['routeIsLoading'];
    },
    filteredCodesByType() {
      let codes = {
        'ORDERTYPE': [],
        'ACTIVITYTYPE': [],
        'ACTIVITY': [],
        'PROBLEM': [],
        'ASSET': [],
        'RESPONSE': [],
        'REACTIVE': [],
        'FAILURE': [],
        'REPAIR': [],
      }
      this.codes_filtered.forEach(code => {
        const type = code.type.toUpperCase();
        if (codes.hasOwnProperty(type)) {
          codes[type].push(code);
        }
      });
      return codes;
    },
    orderTypeCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'ORDERTYPE';
      });
    },
    orderTypeCodesFiltered() {
      return this.extractFilterCodesByType('ORDERTYPE');
    },
    activityTypeCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'ACTIVITYTYPE';
      });
    },
    activityTypeCodesFiltered() {
      return this.extractFilterCodesByType('ACTIVITYTYPE');
    },
    activityCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'ACTIVITY';
      });
    },
    activityCodesFiltered() {
      return this.extractFilterCodesByType('ACTIVITY');
    },
    problemCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'PROBLEM';
      });
    },
    problemCodesFiltered() {
      return this.extractFilterCodesByType('PROBLEM');
    },
    assetCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'ASSET';
      });
    },
    assetCodesFiltered() {
      return this.extractFilterCodesByType('ASSET');
    },
    outcomeCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'REACTIVE';
      });
    },
    outcomeCodesFiltered() {
      return this.extractFilterCodesByType('REACTIVE');
    },
    responsibilityCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'RESPONSE';
      });
    },
    responsibilityCodesFiltered() {
      return this.extractFilterCodesByType('RESPONSE');
    },
    failureCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'FAILURE';
      });
    },
    failureCodesFiltered() {
      return this.extractFilterCodesByType('FAILURE');
    },
    repairCodes() {
      return this.codes_all.filter(code => {
        return code.type.toUpperCase() == 'REPAIR';
      });
    },
    repairCodesFiltered() {
      return this.extractFilterCodesByType('REPAIR');
    },
  },
  mounted() {
    this.$store.dispatch('routeLoading');
    this.fetchCodeSets();
    this.fetchAll()
    .finally(() => {
      this.$store.dispatch('routeLoading', false);
    });
  },
  methods: {
    async fetchCodeSets() {
      this.code_sets = await ContractService.getCodeSets();
    },
    fetchAll() {
      let codes = [];
      this.chainLoading = true;
      return CodeService.all({ start_code_type: this.code_set || undefined })
        .then(data => {
          codes = JsonDenormalizer.denormalize(data);
          this.codes_all = codes;
          return Promise.resolve(codes);
        })
        .catch(err => {
          window.console && console.log(err);
          return Promise.reject(err);
        }).finally(() => {
          this.chainLoading = false;
        });
    },
    resetCodes() {
      let selected = {};
      Object.keys(this.selected).forEach(function(key,index) {
        selected[key] = null;
      });
      this.selected = selected;
    },
    fetchChained: function() {
      const vm = this;
      let code_ids = [];
      vm.chainLoading = true;
      Object.keys(vm.selected).forEach(function(key,index) {
        // key: the name of the object key
        // index: the ordinal position of the key within the object
        if (vm.selected[key]) {
          code_ids.push(vm.selected[key]);
        }
      });
      if ( ! code_ids.length) {
        vm.codes_filtered = [];
        vm.chainLoading = false;
        return Promise.resolve([]);
      }
      return CodeService.chained({ start_code_type: this.code_set || undefined, ids: code_ids})
        .then((response) => {
          let codes_filtered = JsonDenormalizer.denormalize(response);
          vm.codes_filtered = codes_filtered
          return Promise.resolve(codes_filtered)
        })
        .catch(err => {
          return Promise.reject(err);
        })
        .finally(() => {
          vm.chainLoading = false;
        });
    },
    displayCode(code) {
      return '{code} - {name}'
        .replace('{code}', trim(code.code))
        .replace('{name}', trim(code.name));
    },
    extractFilterCodesByType(type) {
      let codes = this.codes_filtered.filter(code => {
        return code.type.toUpperCase() == type.toUpperCase();
      });
      return codes;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Codes/chain/index.vue